module.exports = __webpack_public_path__ + "static/media/education_scholarship.c4846301.jpg";